var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Button, LayoutContent, LayoutContentHeader, LayoutControls, } from '@pinwheel/origami';
import React, { useCallback, useMemo } from 'react';
import { useOpts } from '../../context';
import useOrgName from '../../hooks/useOrgName';
import DetailsTable from '../../LinkApiRouter/components/Table/DetailsTable';
import useSwitchConfirmationAmountText from '../../LinkApiRouter/hooks/useSwitchConfirmationAmountText';
import useBankInfo from '../../LinkApiRouter/hooks/useBankInfo';
import { useGetLocalizedString } from '../../hooks/useGetLocalizedString';
import useSelectedAccountText from '../../LinkApiRouter/hooks/useSelectedAccountText';
function SwitchConfirmation(props) {
    var getLocalizedString = useGetLocalizedString();
    var selectedEmployer = useOpts().selectedEmployer;
    var orgName = useOrgName();
    var bankInfoForm = useBankInfo().bankInfoForm;
    var selectedAccountText = useSelectedAccountText();
    var title = useMemo(function () { return getLocalizedString('SWITCH_CONFIRMATION_TITLE'); }, [getLocalizedString]);
    var subtitle = useMemo(function () { return getLocalizedString('SWITCH_CONFIRMATION_SUBTITLE'); }, [getLocalizedString]);
    var handleSubmit = useCallback(function () {
        props.onContinue();
    }, [props]);
    var amountText = useSwitchConfirmationAmountText();
    return (React.createElement(React.Fragment, null,
        React.createElement(LayoutContent, null,
            React.createElement(LayoutContentHeader, { title: title, subtitle: subtitle }),
            React.createElement(DetailsTable, { data: __spreadArray(__spreadArray(__spreadArray(__spreadArray([], (selectedEmployer
                    ? [
                        {
                            label: getLocalizedString('EMPLOYER'),
                            value: selectedEmployer.name,
                        },
                    ]
                    : []), true), [
                    {
                        label: getLocalizedString('AMOUNT'),
                        value: amountText,
                    },
                    {
                        label: getLocalizedString('FREQUENCY'),
                        value: getLocalizedString('EVERY_PAYCHECK'),
                    },
                    {
                        label: getLocalizedString('DEPOSIT_TO'),
                        value: selectedAccountText || orgName,
                    }
                ], false), (bankInfoForm && bankInfoForm.routingNumber
                    ? [
                        {
                            label: getLocalizedString('ROUTING'),
                            value: bankInfoForm.routingNumber,
                        },
                    ]
                    : []), true), (bankInfoForm && bankInfoForm.accountNumber
                    ? [
                        {
                            label: getLocalizedString('ACCOUNT'),
                            value: bankInfoForm.accountNumber,
                        },
                    ]
                    : []), true) })),
        React.createElement(LayoutControls, null,
            React.createElement(Button, { dataTestId: "SwitchConfirmation-submit", style: {
                    margin: '8px 0',
                }, eventId: "AmountSelection-continue", onClick: handleSubmit }, getLocalizedString('CONFIRM')))));
}
export default SwitchConfirmation;
